import { FilterType } from '@bestseller-bit/frontend-community.bootstrapping.application-shell';
import { useState } from 'react';

export const useFiltersState = () => {
    const [filtersState, setFiltersState] = useState<FilterType[]>([]);

    return [filtersState, setFiltersState] as const;
};
